module.exports = __webpack_public_path__ + "static/img/banner.506578c2.jpg";